import { combineReducers } from 'redux';
import {
  YEAR_RECAP_FETCH,
  YEAR_RECAP_FETCH_SUCCESS,
  YEAR_RECAP_FETCH_ERROR,
} from '../actions/types';

const data = (state = null, action) => {
  switch (action.type) {
    case YEAR_RECAP_FETCH_SUCCESS:
      return action.data;
    case YEAR_RECAP_FETCH_ERROR:
      return null;
    default:
      return state;
  }
};

const isLoading = (state = false, action) => {
  switch (action.type) {
    case YEAR_RECAP_FETCH:
      return true;
    case YEAR_RECAP_FETCH_SUCCESS:
    case YEAR_RECAP_FETCH_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case YEAR_RECAP_FETCH:
    case YEAR_RECAP_FETCH_SUCCESS:
      return null;
    case YEAR_RECAP_FETCH_ERROR:
      return action.error;
    default:
      return state;
  }
};

export const getYearRecapData = (state) => state.yearRecap.data;
export const isYearRecapLoading = (state) => state.yearRecap.isLoading;

export default combineReducers({
  data,
  isLoading,
  error,
});

